import { useEffect } from "react";

export const setAppHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty("--app-height", `${window.innerHeight}px`);
};

// Every page below only ever called setAppHeight() once, in an effect with no cleanup and no
// resize listener - fine for the height the page happened to mount at, but login.scss's
// `.pageWrapper#loginPage` (the background image wrapper) stays pinned to that first value
// forever after. Browser zoom changes window.innerHeight in CSS pixels without a page reload, so
// zooming out after the page has already rendered left the wrapper shorter than the real viewport,
// and background-size: cover can't fill a gap outside its own element's box. Re-running
// setAppHeight on resize (zoom fires it same as a real window resize) keeps the var in sync.
export const useAppHeight = (): void => {
  useEffect(() => {
    setAppHeight();
    window.addEventListener("resize", setAppHeight);
    return () => window.removeEventListener("resize", setAppHeight);
  }, []);
};
